<div>
  <div class="title" [innerHTML]="title | translate"></div>
  <div class="desc" [innerHTML]="desc | translate"></div>
</div>
